import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as XLSX from 'xlsx';
import { DigisubservicesService } from '../services/digisubservices.service';

@Component({
  selector: 'app-issue-seller-prantwise-varganidar-report',
  templateUrl: './issue-seller-prantwise-varganidar-report.component.html',
  styleUrl: './issue-seller-prantwise-varganidar-report.component.scss'
})
export class IssueSellerPrantwiseVarganidarReportComponent implements OnInit {
  isLoading: boolean = false;
  errorMessage = '';

  endDate: any = new Date();

  issue_date = '';
  issueName = '';

  showPrantData: any[] = [
    { prantName: 'कोकण प्रांत' },
    { prantName: 'पश्चिम प्रांत' },
    { prantName: 'देवगिरी प्रांत' },
    { prantName: 'विदर्भ प्रांत' },
  ];
  showOtherPrantData: any[] = [];

  totalPratiTotal = 0;
  totalJamaTotal = 0;
  totalYeneTotal = 0;

  constructor(
    private datePipe: DatePipe,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService
  ) {}

  ngOnInit(): void {
     this.issue_date = this.data['issue_date'] ?? '';
    this.issueName = this.data['category'] ?? ''; 

    if (this.data?.['issuedate']) {
      this.endDate = this.data['issuedate'];
    }

    this.getReportData();
  }

  private parseNum(v: any): number {
    if (v == null) return 0;
    if (typeof v === 'number') return v;
    let s = String(v).replace(/[,₹\s%]/g, '').replace(/[^\d.-]/g, '');
    return s === '' ? 0 : (parseFloat(s) || 0);
  }

  getReportData() {
    this.isLoading = true;
    this.errorMessage = '';

    const req: any = {
      issuedate: this.issue_date,
      category: this.issueName,
    };

    this.service.getPrantDistrictwiseReport(req).subscribe({
      next: (res: any) => {
        const rawPrants: any[] = res?.prants ?? [];
        this.setPrantData(rawPrants, res?.grand_total ?? {});
      },
      error: (err: any) => {
        console.error('Failed to load prantwise varganidar report', err);
        this.errorMessage = 'अहवाल लोड करताना त्रुटी आली.';
        this.isLoading = false;
      }
    });
  }

  // Prant-only totals — no district-level breakdown rows
  setPrantData(rawPrants: any[], grandTotal: any) {
    this.totalPratiTotal = 0;
    this.totalJamaTotal = 0;
    this.totalYeneTotal = 0;
    this.showOtherPrantData = [];

    this.showPrantData.forEach((p: any) => {
      p.prati = 0;
      p.jama = 0;
      p.yene = 0;
    });

    const knownPrantNames = this.showPrantData.map((p) => p.prantName);
    let otherPrati = 0;
    let otherJama = 0;
    let otherYene = 0;

    rawPrants.forEach((p: any) => {
      const pratiTotal = this.parseNum(p.total?.issue_copies);
      const jamaTotal = this.parseNum(p.total?.entry_amount);
      const yeneTotal = this.parseNum(p.total?.remaining_amount);

      if (!p.prant_name || !knownPrantNames.includes(p.prant_name)) {
        otherPrati += pratiTotal;
        otherJama += jamaTotal;
        otherYene += yeneTotal;
        return;
      }

      this.showPrantData.forEach((a: any) => {
        if (a.prantName === p.prant_name) {
          a.prati = pratiTotal;
          a.jama = jamaTotal;
          a.yene = yeneTotal;
        }
      });

      this.totalPratiTotal += pratiTotal;
      this.totalJamaTotal += jamaTotal;
      this.totalYeneTotal += yeneTotal;
    });

    this.showOtherPrantData.push({
      name: 'अन्यप्रांत',
      prati: otherPrati,
      jama: otherJama,
      yene: otherYene
    });

    this.showOtherPrantData.push({
      name: 'परदेश',
      prati: 0,
      jama: 0,
      yene: 0
    });

    this.totalPratiTotal += otherPrati;
    this.totalJamaTotal += otherJama;
    this.totalYeneTotal += otherYene;

    this.isLoading = false;
  }

  exportExcel(fileName) {
    let element = document.getElementById('print-section');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    XLSX.writeFile(wb, fileName + '.xlsx');
  }
}